module.exports = __webpack_public_path__ + "img/display.01d44930.png";